import React, { useEffect, useState, useCallback } from "react";
import { Checkbox } from "semantic-ui-react";
import swal from "sweetalert";
import { producaov2 as api } from "../../../../services/apis";
import { AiOutlineFieldTime } from "react-icons/ai";

const Aprovado = (props) => {
  const [aprovado, setAprovado] = useState(props.projeto.verificado);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setAprovado(props.projeto.verificado);
  }, [props.projeto]);

  const aprovar = useCallback(async () => {
    const { projeto } = props;

    console.log("APROVAD", aprovado);

    const verificadoFinal = aprovado === 1 ? 0 : 1;
    setLoading(true);

    const data = { verificado: verificadoFinal };

    api
      .put(`projetos/all/${projeto.id}`, data)
      .then((v) => {
        setAprovado(verificadoFinal);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        swal(
          "Ocorreu um erro ao atualizar aprovação!",
          "Houve um erro ao salvar os dados do arquivo enviado. Se o erro persistir, nos contate.",
          "error"
        );
        return false;
      });
  }, [props, aprovado]);

  if (loading) {
    return <AiOutlineFieldTime size={24} />;
  }

  if (props.projeto.verificado === null) {
    return null;
  }

  return (
    <>
      <span>{aprovado ? "Retirar aprovação" : "Aprovar:"}</span>
      <br />
      <Checkbox checked={aprovado} onClick={aprovar} toggle />
    </>
  );
};

export default Aprovado;
